// extracted by mini-css-extract-plugin
export default {"help-link":"WebChat_help-link__6VBM-","loading-value":"WebChat_loading-value__4sEJP"};